import script from "./FilterButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterButtons.vue?vue&type=script&setup=true&lang=js"

import "./FilterButtons.vue?vue&type=style&index=0&id=8170a26c&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8170a26c"]])

export default __exports__